import { useState } from "react";
import { Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { uploadImage } from "@/lib/upload";
import { fileUrl } from "@/lib/activity";
import { errMsg } from "@/lib/api";

export const ImageField = ({ value, onChange, folder = "people", testId, square = true }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadImage(file, folder));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-3">
      <div className={`${square ? "h-16 w-16" : "h-16 w-28"} rounded-2xl bg-slate-50 border border-dashed border-emerald-900/20 overflow-hidden flex items-center justify-center shrink-0`}>
        {value ? <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" data-testid={`${testId}-preview`} /> : <Upload size={16} className="text-slate-400" />}
      </div>
      <label className="inline-flex items-center gap-2 rounded-full border border-emerald-900/15 px-3 py-1.5 text-xs font-medium cursor-pointer hover:bg-emerald-50">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {value ? "Ganti" : "Unggah"}
        <input type="file" accept="image/*" className="hidden" disabled={busy} onChange={(e) => pick(e.target.files?.[0])} data-testid={testId} />
      </label>
      {value && <button type="button" onClick={() => onChange("")} className="text-slate-400 hover:text-red-600" data-testid={`${testId}-remove`}><X size={14} /></button>}
    </div>
  );
};
